function canView(pagePermission: PagePermission, userRole: AccountUserRole): boolean {
  if (pagePermission.canView) {
    return pagePermission.canView.includes(userRole)
  }
  return false
}

function canCreate(pagePermission: PagePermission, userRole: AccountUserRole): boolean {
  if (pagePermission.canCreate) {
    return pagePermission.canCreate.includes(userRole)
  }
  return false
}

function canEdit(pagePermission: PagePermission, userRole: AccountUserRole): boolean {
  if (pagePermission.canEdit) {
    return pagePermission.canEdit.includes(userRole)
  }
  return false
}

function canDelete(pagePermission: PagePermission, userRole: AccountUserRole): boolean {
  if (pagePermission.canDelete) {
    return pagePermission.canDelete.includes(userRole)
  }
  return false
}

export function useRolePermission() {
  return {
    canView,
    canCreate,
    canEdit,
    canDelete,
  }
}

export function usePagePermissions(customPermission?: PagePermission) {
  const route = useRoute()
  const { userSettings } = useNuxtApp().$store

  const pagePermission = computed(() => customPermission || route.meta.pagePermission as PagePermission)
  const userRoles = computed(() => userSettings.userRoles as Array<AccountUserRole>)

  const hasPermission = (checkFn: (pagePermission: PagePermission, userRole: AccountUserRole) => boolean) => {
    return computed(() => {
      if (!userRoles.value?.length || !pagePermission.value) {
        return false
      }
      return userRoles.value.some(role => checkFn(pagePermission.value, role))
    })
  }

  return {
    canView: hasPermission(canView),
    canCreate: hasPermission(canCreate),
    canEdit: hasPermission(canEdit),
    canDelete: hasPermission(canDelete),
  }
}
